import omit from 'lodash/omit';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';

import SelectProviderInput from '../providers/SelectProviderInput';
import ProviderChip from '../providers/ProviderChip';
import SelectLocationInput from '../locations/SelectLocationInput';

const filtersSettings = [
  {
    name: 'provider_id',
    Component: props => (
      <Stack direction='row' spacing={1}>
        {
          props.filters.provider_id
          ? <ProviderChip 
            providerId={props.filters.provider_id} 
            onDelete={() => props.onFilterChange(omit(props.filters, 'provider_id'))}
            deleteIcon={<CloseIcon />}
          />
          : <Box sx={{width: {xs: '100%', md: '150px'}}}>
            <SelectProviderInput
              label={null}
              placeholder='Provider'
              defaultValue={props.filters?.provider_id}
              fullWidth={true}
              onChange={e => {
                if (e.target?.type === 'text') return () => true;
                return (
                  e.target.value
                  ? props.onFilterChange({...props.filters, provider_id: e.target.value})
                  : props.onFilterChange(omit(props.filters, 'provider_id'))
                );
              }}
            />
          </Box>
        }
      </Stack>
    ),
  },
  {
    name: 'facility_id',
    Component: props => (
      <Grid item xs={6} md='auto'>
        {
          props.filters.facility_id
          ? <Chip
            label='Team'
            onDelete={() => props.onFilterChange(omit(props.filters, 'facility_id'))}
            deleteIcon={<CloseIcon />}
          />
          : <Box sx={{width: {xs: '100%', md: '150px'}}}>
            <SelectLocationInput
              label={null}
              placeholder='Team'
              defaultValue={props.filters?.facility_id}
              sx={{width: '200px'}}
              onChange={e => {
                if (e.target?.type === 'text') return () => true;
                return (
                  e.target.value
                  ? props.onFilterChange({...props.filters, facility_id: e.target.value})
                  : props.onFilterChange(omit(props.filters, 'facility_id'))
                );
              }}
            />
          </Box>
        }
      </Grid>
    ),
  }
];

const parseFilters = ({allowedFilters}) => filter => {
  return allowedFilters.reduce((acc, next) => {
    if (filter[next.queryParam] === undefined) return acc;
    return {...acc, [next.filterName]: filter[next.queryParam]};
  }, {});
};

const unparseFilters = ({allowedFilters}) => filters => {
  return allowedFilters.reduce((acc, next) => {
    if (filters[next.filterName] === undefined) return acc;
    return {...acc, [next.queryParam]: filters[next.filterName]};
  }, {});
};

const handleFilterChange = ({onFilterChange, allowedFilters}) => val => {
  console.log('ReportFilters.handleFilterChange with val:', val);
  const _filters = unparseFilters({allowedFilters})(val);
  onFilterChange(_filters);
};

const ReportFilters = ({filter = {}, allowedFilters = [], onFilterChange}) => {
  const _filters = parseFilters({allowedFilters})(filter);
  const _onFilterChange = handleFilterChange({
    onFilterChange, 
    allowedFilters,
    filters: _filters
  });
  console.log('ReportFilters render with filters:', filter, _filters);
  return (
    <Box style={{paddingBottom: '1em'}}>
      <Stack direction='row' spacing={1} flexWrap='wrap'>
        {allowedFilters.map(f => {
          const match = filtersSettings.find(({name}) => name === f.filterName);
          if (match) {
            return (
              <match.Component 
                key={f.filterName} 
                filters={_filters} 
                onFilterChange={_onFilterChange} 
              />
            );
          }
        })}
      </Stack>
    </Box>
  );
};

export default ReportFilters;